'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'user-chef';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e3d2';
var svgPathData = 'M148 .3c-8.8-10-21.7-16.3-36-16.3-26.5 0-48 21.5-48 48 0 20.9 13.4 38.7 32 45.3L96 144c0 70.7 57.3 128 128 128s128-57.3 128-128l0-66.7c18.6-6.6 32-24.4 32-45.3 0-26.5-21.5-48-48-48-14.3 0-27.2 6.3-36 16.3-8.8-10-21.7-16.3-36-16.3-16.7 0-31.4 8.5-40 21.5-8.6-12.9-23.3-21.5-40-21.5-14.3 0-27.2 6.3-36 16.3zM304 128l0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16 160 0zM96 439.6c0-36.4 20.5-69.6 53.1-85.9l39.2-19.6-54.8-27.4c-3.6-1.8-7.6-2.7-11.6-2.7-14.3 0-25.9 11.6-25.9 25.9l0 14.1-4.5 2.7C44.6 374.8 16 425.4 16 480 16 497.7 30.3 512 48 512l48 0 0-72.4zM128 512l272 0c17.7 0 32-14.3 32-32 0-54.6-28.6-105.2-75.5-133.3l-4.5-2.7 0-14.1c0-14.3-11.6-25.9-25.9-25.9-4 0-8 .9-11.6 2.7L163.4 382.3c-21.7 10.8-35.4 33-35.4 57.2l0 72.4zm152-80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-72-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserChef = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;